<template>
  <div class="footer-links">
    <div class="footer-info">
      <img src="../assets/logo.png" class="footer-logo" alt="logo" srcset="" />
      <p>{{ $t("footer.text") }}</p>
      <div class="social-links">
        <a href="https://facebook.com" target="_blank">
          <img src="../assets/facebook.svg" alt="facebook" srcset="" />
        </a>
        <a href="https://x.com" target="_blank">
          <img src="../assets/twitter.svg" alt="twitter" srcset="" />
        </a>
        <a href="https://discord.com" target="_blank">
          <img src="../assets/discord.svg" alt="discord" srcset="" />
        </a>
      </div>
      <p>&copy; {{ new Date().getFullYear() }} {{ $t("footer.copyright") }}</p>
    </div>
    <div class="footer-nav">
      <div class="footer-nav-left">
        <ul>
          <li>
            <router-link to="/pages/about" @click.native="scrollToTop">{{
              $t("footer.links.about")
            }}</router-link>
          </li>
          <li>
            <router-link to="/pages/traffic-mining" @click.native="scrollToTop">{{
              $t("footer.links.traffic")
            }}</router-link>
          </li>
          <li>
            <router-link to="/pages/nft-gsg" @click.native="scrollToTop">{{
              $t("footer.links.nft")
            }}</router-link>
          </li>
          <li>
            <router-link to="/pages/team" @click.native="scrollToTop">{{
              $t("footer.links.team")
            }}</router-link>
          </li>
          <li>
            <router-link to="/pages/contact" @click.native="scrollToTop">{{
              $t("footer.links.contact")
            }}</router-link>
          </li>
        </ul>
      </div>
      <div class="footer-nav-center">
        <ul>
<!--          <li>-->
<!--            <router-link to="/pages/investor" @click.native="scrollToTop">{{-->
<!--              $t("footer.links.investor")-->
<!--            }}</router-link>-->
<!--          </li>-->
          <li>
            <router-link to="/pages/beta" @click.native="scrollToTop"
              >{{ $t("footer.links.beta") }}</router-link
            >
          </li>
          <li>
            <router-link to="/pages/careers" @click.native="scrollToTop">{{
              $t("footer.links.careers")
            }}</router-link>
          </li>
        </ul>
      </div>
      <div class="footer-nav-right">
        <ul>
          <li>
            <router-link to="/pages/terms" @click.native="scrollToTop">{{
              $t("footer.links.terms")
            }}</router-link>
          </li>
          <li>
            <router-link to="/pages/privacy" @click.native="scrollToTop">{{
              $t("footer.links.privacy")
            }}</router-link>
          </li>
        </ul>
        <div class="app-links">
          <div class="app-link">
            <a href="">
              <img
                src="../assets/GetItOnGooglePlay.png"
                alt="Google Play"
                srcset=""
              />
            </a>
          </div>
          <div class="app-link">
            <a href="">
              <img
                src="../assets/Download_on_the_App_Store.svg"
                alt="Apple App Store"
                srcset=""
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterLinks",
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
.footer-links {
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 0;
  font-size: 15px;
}
.footer-info {
  width: 100%;
  text-align: center;
  margin-top: 3rem;
  .footer-logo {
    width: 50%;
  }
  p {
    line-height: 2rem;
    width: 100%;
  }
  .social-links {
    margin-bottom: 2rem;
    a {
      margin-right: 1rem;
    }
    img {
      height: 30px;
    }
  }
}
.footer-nav {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .footer-nav-left,
  .footer-nav-center,
  .footer-nav-right {
    width: 100%;
    text-align: center;
  }
  ul {
    padding: 0;
    margin: 0 0 4rem;
    list-style: none;
  }
  li {
    margin-bottom: 2rem;
    a {
      text-decoration: none;
      color: white;
    }
  }
  .app-links {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 3rem;
    gap: 0.3rem;
    .app-link {
      width: 50%;
      img {
        width: 100%;
      }
    }
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .footer-nav {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: baseline;
    ul {
      padding: 0;
      margin: 0 0 1rem;
      list-style: none;
    }
    li {
      margin-bottom: 1rem;
      a {
        text-decoration: none;
        color: white;
      }
    }
    .app-links {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 3rem;
      gap: 0.3rem;
      img {
        max-width: 114px;
      }
      .app-link {
        max-width: 114px;
      }
    }
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .footer-links {
    width: 100%;
    max-width: 1312.38px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    padding: 1.5rem 0;
    font-size: 15px;
  }
  .footer-info {
    width: 40%;
    margin-top: 0;
    text-align: start;
    p {
      line-height: 2rem;
      width: 75%;
    }
    .social-links {
      margin-bottom: 2rem;
      a {
        margin-right: 1rem;
      }
      img {
        height: 30px;
      }
    }
  }
  .footer-nav {
    width: 60%;
    display: flex;
    justify-content: space-around;
    align-items: baseline;
    .footer-nav-left,
    .footer-nav-center,
    .footer-nav-right {
      width: 100%;
      text-align: start;
    }
    ul {
      padding: 0;
      margin: 0 0 1rem;
      list-style: none;
    }
    li {
      margin-bottom: 1rem;
      a {
        text-decoration: none;
        color: white;
      }
    }
    .app-links {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-top: 3rem;
      gap: 0.3rem;
    }
  }
}
/* X-Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>
